module.exports = __webpack_public_path__ + "static/media/Scraggy_gaussian2.6b4c3b95.png";